import script from "./ToolBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToolBar.vue?vue&type=script&lang=ts&setup=true"

import "./ToolBar.vue?vue&type=style&index=0&id=066388d5&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066388d5"]])

export default __exports__